module.exports = __webpack_public_path__ + "static/media/iros21-3.af0b7edc.png";